import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/atom-one-dark.css";

const tableWrap = { overflowX: "auto", margin: "16px 0", WebkitOverflowScrolling: "touch" };

const MarkdownRenderer = ({ content, onCheckboxToggle, className = "" }) => {
  const checkboxDisabled = !onCheckboxToggle;
  const components = {
    input: ({ checked, ...props }) => {
      if (props.type === "checkbox") {
        return (
          <input
            type="checkbox"
            checked={checked}
            disabled={checkboxDisabled}
            onChange={(e) => {
              if (!checkboxDisabled && onCheckboxToggle) {
                onCheckboxToggle(checked, e.target.checked);
              }
            }}
            style={{
              cursor: checkboxDisabled ? "not-allowed" : "pointer",
              opacity: checkboxDisabled ? 0.6 : 1,
              margin: "0 8px 0 0",
              verticalAlign: "middle",
            }}
          />
        );
      }
      return <input {...props} disabled />;
    },
    table: ({ children, ...props }) => (
      <div style={tableWrap}>
        <table {...props}>{children}</table>
      </div>
    ),
  };

  return (
    <div className={`markdown-body ${className}`.trim()}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeHighlight]}
        components={components}
      >
        {content == null ? "" : typeof content === "string" ? content : String(content)}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
